var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.84846 7.36007H9.21803V14.3894C9.21803 15.1026 9.79628 15.6801 10.5087 15.6801H14.0318C14.7442 15.6801 15.3225 15.1026 15.3225 14.3894V7.36007H17.6913C18.0837 7.36007 18.4364 7.12379 18.5873 6.76115C18.7367 6.39999 18.6536 5.98246 18.3763 5.7052L12.9552 0.283398C12.5765 -0.094466 11.9632 -0.094466 11.5837 0.283398L6.1635 5.7052C5.88619 5.98246 5.8031 6.39927 5.95324 6.76115C6.10404 7.12308 6.45604 7.36007 6.84846 7.36007Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.8131 9.99512C22.1707 9.99512 21.6496 10.5163 21.6496 11.1593V16.0272C21.6496 17.4854 20.4625 18.6717 19.0042 18.6717H5.53596C4.07765 18.6717 2.89137 17.4854 2.89137 16.0272V11.1593C2.89137 10.5163 2.36947 9.99512 1.72718 9.99512C1.08412 9.99512 0.562988 10.5163 0.562988 11.1594V16.0272C0.562988 18.7693 2.79382 21.0002 5.53596 21.0002H19.0042C21.7464 21.0002 23.9773 18.7693 23.9773 16.0272V11.1594C23.9773 10.5163 23.4561 9.99512 22.8131 9.99512Z",
    fill: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBlack);
export default __webpack_public_path__ + "static/media/uploadBlack.2e379528631cd37856ff35fdd9a96ffc.svg";
export { ForwardRef as ReactComponent };